// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fAPnzHqZu3oZFBpmqqDD{padding:8px 24px 24px}.pzgEQQT8gCQsVwYWUAYX{padding:0 24px 24px}.lW7HVtDYlN0vQiX8YvXk{background:var(--background-neutral-subtle);border:1px solid rgba(0,0,0,.04);border-radius:8px;flex-direction:column;justify-content:center;align-self:stretch;align-items:center;gap:8px;width:492px;padding:40px 0;display:flex;box-shadow:inset 0 -6px 17px rgba(20,22,26,.03)}._1VyPsVT5nYXKyON9fMo{padding:0 24px 16px}.YftBjIExgRofPoqrlwhy{align-items:center;height:48px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `fAPnzHqZu3oZFBpmqqDD`,
	"wrapInfo": `pzgEQQT8gCQsVwYWUAYX`,
	"info": `lW7HVtDYlN0vQiX8YvXk`,
	"controls": `_1VyPsVT5nYXKyON9fMo`,
	"loading": `YftBjIExgRofPoqrlwhy`
};
export default ___CSS_LOADER_EXPORT___;
